<template>
  <div class="container my-3">
    <b-card class="rounded-lg">
      <h2 class="mb-2">Information om cookies</h2>
      <p>
        Här informerar vi om hur AutoFaktura använder cookies och liknande
        tekniker i enlighet med dataskyddsförordningen (GDPR) och lagen om
        elektronisk kommunikation.
      </p>

      <h4>Vad är cookies?</h4>
      <p>
        Cookies är små textfiler som lagras lokalt i din webbläsare när du
        besöker en webbplats. De används för att webbplatsen ska fungera
        tekniskt, samt för att komma ihåg dina val och inställningar. Cookies
        kan vara antingen sessionscookies (som raderas när du stänger
        webbläsaren) eller permanenta cookies (som sparas under en längre tid).
      </p>

      <h4>Syfte med vår användning av cookies</h4>
      <p>
        AutoFaktura använder cookies uteslutande för att säkerställa tjänstens
        grundläggande funktionalitet och säkerhet. Cookies möjliggör
        autentisering och session management så att du kan förbli inloggad under
        ditt besök. De används även för säkerhetsåtgärder, bland annat för att
        förhindra cross-site request forgery-attacker (CSRF-skydd). Vi använder
        inte cookies för marknadsföring, beteendeanalys, profilering eller
        tredjepartsspårning.
      </p>

      <h4>Förstaparts- och tredjepartscookies</h4>
      <p>
        Förstapartscookies sätts direkt av den webbplats du besöker
        (autofaktura.com) och kan endast läsas av denna webbplats.
        Tredjepartscookies sätts av externa tjänsteleverantörer, såsom
        analysverktyg, annonsnätverk eller sociala medier, via innehåll som
        laddas in på webbplatsen. AutoFaktura använder enbart förstapartscookies
        som är tekniskt nödvändiga för tjänstens funktion.
      </p>

      <h4>Vilka cookies använder vi?</h4>
      <p>
        AutoFaktura använder två förstapartscookies som är tekniskt nödvändiga:
        (1) En sessionscookie som upprätthåller din autentisering och håller dig
        inloggad under hela din session. (2) En CSRF-skyddscookie som förhindrar
        obehörig användning och säkerställer att förfrågningar till tjänsten
        kommer från dig och inte från tredje part. Båda cookies är strikt
        nödvändiga för att tjänsten ska fungera säkert och korrekt.
      </p>

      <h4>Samtycke och dina val</h4>
      <p>
        Enligt lagen om elektronisk kommunikation krävs inte samtycke för
        cookies som är strikt nödvändiga för att tillhandahålla en tjänst som du
        uttryckligen har begärt. Eftersom AutoFaktura enbart använder sådana
        tekniskt nödvändiga förstapartscookies, finns det för närvarande inga
        valfria cookies att acceptera eller neka. Om vi i framtiden skulle
        införa icke-nödvändiga cookies, exempelvis för analys eller
        marknadsföring, kommer vi att inhämta ditt samtycke innan dessa används,
        i enlighet med gällande lagstiftning.
      </p>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Cookies",
};
</script>

<style scoped></style>
